module.exports = __webpack_public_path__ + "img/logo.ba42eb9e.png";